import { APP_POOL_CONFIG } from '@synergy/config';
import { PoolRow, PoolRowProps, PoolTypography } from '@synergy/components-next';
import { PropsWithChildren, ReactElement } from 'react';
import { styled } from '@mui/material';

export const StyledRow = styled(PoolRow)(({ theme }) => ({
    ...theme.typography.body1,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1),
    textAlign: 'left',
    alignItems: 'start',
}));

export interface ErrorTextProps extends PoolRowProps {
    statusCode?: string | null;
}

export const ErrorText = (props: PropsWithChildren<ErrorTextProps>): ReactElement => {
    const { statusCode, children, ...rowProps } = props;
    return (
        <StyledRow {...rowProps}>
            {children}
            <PoolTypography
                translationId={statusCode ? `app.login.error.${statusCode}` : 'app.login.error'}
                values={{ poolConfigNameShort: APP_POOL_CONFIG['name_short'] }}
            />
        </StyledRow>
    );
};
